module.exports = __webpack_public_path__ + "img/pin.4f91ed5b.svg";